import { render, staticRenderFns } from "./a-image-v2.vue?vue&type=template&id=1165782f&scoped=true"
import script from "./a-image-v2.vue?vue&type=script&lang=js"
export * from "./a-image-v2.vue?vue&type=script&lang=js"
import style0 from "./a-image-v2.vue?vue&type=style&index=0&id=1165782f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1165782f",
  null
  
)

export default component.exports